import { uploadFile } from "./FetchUtil";
import { Message, MessageSendingDTO, ReadStatus } from "../models/Message";
import { ChatSession } from "../models/ChatSession";
import { SubscriptionDetails } from "../hooks/useStompClient";
import { tokenUsername } from "./TokenUtil";

export const createMessageAndDTO = async (
  activeSession: ChatSession,
  content: string,
  file: File | null = null,
) => {
  let hashS3Key;
  if (file != null) {
    hashS3Key = await uploadFile(file);
  } else {
    hashS3Key = null;
  }
  const reqId = crypto.randomUUID();
  const messageDTO: MessageSendingDTO = {
    reqId: reqId,
    content: content,
    fileName: file?.name ?? null,
    hashS3Key: hashS3Key,
  };
  const newMessage: Message = {
    reqId: reqId,
    messageId: null,
    sessionId: activeSession.sessionId,
    senderType: "ADMIN",
    content: content,
    fileName: file?.name ?? null,
    hashS3Key: hashS3Key,
    isoCreatedAt: new Date().toISOString(),
    status: ReadStatus.UNREAD,
    senderName: tokenUsername(),
  };

  return { newMessage: newMessage, messageDTO: messageDTO };
};

export const areSubscriptionsDifferent = (
  oldSubscriptions: SubscriptionDetails[],
  newSubscriptions: SubscriptionDetails[],
) => {
  return oldSubscriptions.toString() !== newSubscriptions.toString();
};
